var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroupNotFound = function SvgGroupNotFound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141,
    height: 96,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#5D6470"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.6,
    d: "M110.94 71.12c.29-1.2.46-2.45.46-3.75 0-8.91-7.22-16.13-16.13-16.13H67.63c-8.91 0-16.13 7.22-16.13 16.13 0 .68.06 1.35.14 2.01h-.02c-4.94 0-8.95 4.01-8.95 8.95s4.01 8.95 8.95 8.95h54.04c4.94 0 8.95-4.01 8.95-8.95 0-2.97-1.45-5.59-3.67-7.21ZM27.68 94.74c4.164 0 7.54-2.086 7.54-4.66s-3.376-4.66-7.54-4.66-7.54 2.086-7.54 4.66 3.376 4.66 7.54 4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F8",
    strokeMiterlimit: 10,
    strokeWidth: 1.6,
    d: "m96.61 4.88-34.5 46c-.34.46-.1 1.11.46 1.23l46.83 10.17a.78.78 0 0 0 .93-.93L98.01 5.19c-.14-.65-.99-.84-1.39-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3,
    d: "m91.25 37.15 11.16 11.15M86.08 42.32l11.16 11.15M102.41 42.32 91.25 53.47M97.24 37.15 86.08 48.3"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "m61.88 5.94 7.5-2.77M64.25.8l2.76 7.51"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 1.6,
    d: "M130.08 41.47a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.6,
    d: "M42.89 32.13c1.84-2.48 2.92-5.42 2.92-8.58 0-8.87-8.4-16.07-18.75-16.07S8.3 14.67 8.3 23.55s8.4 16.07 18.75 16.07c2.72 0 5.3-.51 7.63-1.4l8.19 3.94c.89.43 1.89-.34 1.7-1.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D6470",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "M27.05 32.48a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM27.05 13.73c.34 0 .62.28.62.63v12.5a.625.625 0 0 1-1.25-.01v-12.5c0-.34.28-.62.63-.62Z"
  }))));
};
export default SvgGroupNotFound;